import PropType from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

const CheckoutAllowCustomQuote = ({ buyer, deliveryOptions = [], children }) => {
    const hasPreQuotes = !!(deliveryOptions || []).find(
        o => !o?.isLocalPickup && !o?.showQuoteAsPending
    );
    const isVipOrTradeBuyer = buyer?.isVerifiedTrade || buyer?.isVip;
    const allowCustomQuote = isVipOrTradeBuyer && hasPreQuotes;
    return children({ allowCustomQuote });
};

CheckoutAllowCustomQuote.propTypes = {
    buyer: PropType.object.isRequired,
    deliveryOptions: PropType.array,
    children: PropType.func.isRequired,
};

export default createFragmentContainer(CheckoutAllowCustomQuote, {
    buyer: graphql`
        fragment CheckoutAllowCustomQuote_buyer on User {
            isVerifiedTrade: hasPermission(name: "B_NET_PRICE")
            isVip
        }
    `,
    deliveryOptions: graphql`
        fragment CheckoutAllowCustomQuote_deliveryOptions on ShipmentQuote @relay(plural: true) {
            isLocalPickup
            showQuoteAsPending
        }
    `,
});
